import { useState, useEffect } from 'react';
import api from '../api';

const EMPTY_FORM = { name: '', code: '', address: '', contact_name: '', phone: '', email: '', is_active: true };

export default function Locations() {
  const [locations, setLocations] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);

  const fetchLocations = async () => {
    const res = await api.get('/api/locations/');
    setLocations(res.data);
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) {
        await api.put(`/api/locations/${editing.id}`, form);
      } else {
        await api.post('/api/locations/', form);
      }
      setShowForm(false);
      setEditing(null);
      setForm(EMPTY_FORM);
      fetchLocations();
    } catch (err) {
      alert('Hata: ' + (err.response?.data?.detail || 'Bilinmeyen hata'));
    }
  };

  const handleEdit = (location) => {
    setEditing(location);
    setForm(location);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Depoyu silmek istediğinize emin misiniz?')) return;
    await api.delete(`/api/locations/${id}`);
    fetchLocations();
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold text-gray-800">Depolar</h2>
        <button onClick={() => { setShowForm(true); setEditing(null); setForm(EMPTY_FORM); }} className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 font-medium text-sm">
          + Yeni Ekle
        </button>
      </div>

      {showForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-lg max-h-screen overflow-y-auto">
            <h3 className="text-lg font-bold mb-4">{editing ? 'Depo Düzenle' : 'Yeni Depo'}</h3>
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Depo Adı *</label>
                  <input required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full border rounded px-3 py-2" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Kod</label>
                  <input value={form.code || ''} onChange={e => setForm({...form, code: e.target.value})} className="w-full border rounded px-3 py-2" />
                </div>
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Adres</label>
                  <textarea value={form.address || ''} onChange={e => setForm({...form, address: e.target.value})} className="w-full border rounded px-3 py-2" rows={2} />
                </div>
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">İlgili</label>
                  <input value={form.contact_name || ''} onChange={e => setForm({...form, contact_name: e.target.value})} className="w-full border rounded px-3 py-2" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Telefon</label>
                  <input type="tel" value={form.phone || ''} onChange={e => setForm({...form, phone: e.target.value})} className="w-full border rounded px-3 py-2" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">E-posta</label>
                  <input type="email" value={form.email || ''} onChange={e => setForm({...form, email: e.target.value})} className="w-full border rounded px-3 py-2" />
                </div>
              </div>
              <div className="flex gap-3 mt-6">
                <button type="submit" className="flex-1 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 font-medium">Kaydet</button>
                <button type="button" onClick={() => setShowForm(false)} className="flex-1 bg-gray-100 text-gray-700 py-2 rounded-lg hover:bg-gray-200 font-medium">İptal</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Depo Adı</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Kod</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Adres</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">İlgili</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Telefon</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">E-posta</th>
              <th className="text-right px-4 py-3 text-sm font-medium text-gray-500">İşlemler</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {locations.map(l => (
              <tr key={l.id} className="hover:bg-gray-50">
                <td className="px-4 py-3 font-medium text-gray-800">{l.name}</td>
                <td className="px-4 py-3 text-sm font-mono text-gray-600">{l.code || '-'}</td>
                <td className="px-4 py-3 text-gray-600 text-sm">{l.address || '-'}</td>
                <td className="px-4 py-3 text-gray-600 text-sm">{l.contact_name || '-'}</td>
                <td className="px-4 py-3 text-gray-600 text-sm">{l.phone || '-'}</td>
                <td className="px-4 py-3 text-gray-600 text-sm">{l.email || '-'}</td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => handleEdit(l)} className="text-blue-600 hover:text-blue-800 font-medium text-sm mr-2">Düzenle</button>
                  <button onClick={() => handleDelete(l.id)} className="text-red-500 hover:text-red-700 font-medium text-sm">Sil</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {locations.length === 0 && (
          <div className="text-center py-12 text-gray-400">Henüz depo eklenmemiş</div>
        )}
      </div>
    </div>
  );
}
